import { FC } from "react";
import { TitleStyled } from "./Title.style";
import { TitlePropsType } from "./Title.types";

const Title: FC<TitlePropsType> = ({ title, className }) => {
  return <TitleStyled className={`mb-3 ${className}`}>{title}</TitleStyled>;
};

export default Title;
